'use client';
import { setSortingOption } from '@/redux/reducers/sorting.reducer';

import { useAppDispatch, useAppSelector } from './use-redux.hook';
import { SORTING_PLANS } from '@/types/filter.types';
import { useAnalytics } from '@/integrations';
import { useRef } from 'react';

const useSort = () => {
    const dispatch = useAppDispatch();
    const { trackEvent } = useAnalytics();
    const { sorting_plan } = useAppSelector(state => state.sort);
    const isExpSortingApplied = useRef(false);
    // TODO:: END DELETE AFTER EXP END SEARCH IN PROJECT FOR CODE SORTING_EXP_X1
    // const FEATURE_FLAG_WAREHOUSE_INSPECTION_SELECTION =
    //     'car-listing-weight-sorting';
    // //
    // const selectedSorting = useFeatureValue<SORTING_PLANS>(
    //     FEATURE_FLAG_WAREHOUSE_INSPECTION_SELECTION,
    //     SORTING_PLANS.PENDING
    // );
    // useEffect(() => {
    //     if (
    //         !isExpSortingApplied.current &&
    //         selectedSorting !== SORTING_PLANS.PENDING &&
    //         sorting_plan === SORTING_PLANS.DEFAULT
    //     ) {
    //         isExpSortingApplied.current = true;
    //
    //         setSortOptions(selectedSorting as SORTING_PLANS, true);
    //     }
    // }, [selectedSorting]);
    // TODO:: END DELETE AFTER EXP END SEARCH IN PROJECT FOR CODE SORTING_EXP_X1

    const setSortOptions = (
        sortOption: SORTING_PLANS,
        allowTracking = true
    ) => {
        if (!SORTING_PLANS[sortOption] || sortOption === sorting_plan) return;
        isExpSortingApplied.current = true;
        dispatch(setSortingOption(sortOption));
        if (allowTracking) {
            trackEvent('Action: Sort', {
                usedSorting: sortOption,
            });
        }
    };

    return {
        setSortOptions,
        sorting_plan,
    };
};
export default useSort;
